import * as React from 'react'
import { ReactElement } from 'react'
import FixedPriceList from '../../../components/List/FixedPrice/FixedPriceList'
import { FixedPriceOverviewDto } from '../../../config/registrationConfig'
import { RegistrationListProps } from '../../../components/List/Registration/RegistrationList'

export default function FixedPriceOverview(props: RegistrationListProps<FixedPriceOverviewDto>): ReactElement {
    return <FixedPriceList {...props} />
}
